import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ICheckIn } from "./ICheckIn";
import { useCompanyData } from "../../context/CompanyDataContext";
import tervurenLogo from "../../assets/images/shepherd-badge-inverted.png";
import DotSpinner from "../spinner/DotSpinner";

import { getObjectFromS3 } from "../../helpers/s3Helpers";
// import sendWebSocketMessage from '../../services/WebSocket/sendWebSocketMessage/SendWebSocketMessage';

// httpservice passed using dependency injection
const Checkin: React.FC<ICheckIn> = ({ httpService }) => {
	const { setCompanyData } = useCompanyData();
	// Define state variables to store companyId and locationId
	const [loading, setLoading] = useState<boolean>(false);
	const [location, setLocation] = useState<any>(null);
	const [mapDefault, setMapDefault] = useState<string>("");
	const [logoDefault, setLogoDefault] = useState<string>("");

	const handleCheckInClick = () => {
		navigate(
			`/who-are-you/${companyIdParam}/${regionIdParam}/${locationIdParam}`,
		); // Navigate to the test screen
	};

	// this will run everytime the component is rendered
	// temporary fix to clear out old user local data that is no longer needed and may cause issues
	useEffect(() => {
		/* local‑storage clean‑up + redirect */
		[
			`checkedIn-${locationIdParam}`,
			`locationId-${locationIdParam}`,
			`outOfDate-${locationIdParam}`,
			`traineeData-${locationIdParam}`,
			`companyData-${locationIdParam}`,
		].forEach((key) => localStorage.removeItem(key));
	}, []);

	//   useEffect(() => {
	//     // sendWebSocketMessage(`locationId=${locationIdParam}`, `Trainee`);
	//     getObjectFromS3('tervuren-assets', 'images/map-placeholder.png')
	//       .then((content) => {
	//         setMapDefault(content);
	//       })
	//       .catch((error) => console.error('Error loading file from S3', error));

	//     getObjectFromS3('tervuren-assets', 'images/logo-placeholder.png')
	//       .then((content) => {
	//         setLogoDefault(content);
	//       })
	//       .catch((error) => console.error('Error loading file from S3', error));
	//   }, []);
	useEffect(() => {
		setMapDefault(
			"https://tervuren-assets.s3.us-east-2.amazonaws.com/images/map-placeholder.png",
		);
		setLogoDefault(
			"https://tervuren-assets.s3.us-east-2.amazonaws.com/images/logo-placeholder.png",
		);
	}, []);

	// Use the useParams hook to get companyId and locationId from the URL
	const {
		companyId: companyIdParam = "",
		regionId: regionIdParam = "",
		locationId: locationIdParam = "",
	} = useParams<{ companyId: string; regionId: string; locationId: string }>();

	const navigate = useNavigate();

	// usually we only want one use effect but in this case we need to fetch data based on the locationId
	useEffect(() => {
		// Set loading as false to show a screen right away with semantic meaning
		setLoading(false);
		// Store the URL parameters in state variables

		// Fetch data based on companyId and locationId
		httpService
			.getData(`location/id/${locationIdParam}`)
			.then((responseData) => {
				setLocation(responseData); // Update data with the response data
				setCompanyData(responseData); // Save data to context
				setLoading(true);
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}, [
		httpService,
		companyIdParam,
		regionIdParam,
		locationIdParam,
		setCompanyData,
	]);

	if (loading === true) {
		return (
			<div className="tervuren-checkin-container">
				{location ? (
					<div className="tervuren-container__column-center bg-white-navy-linear flex-gap-1 mh-100">
						{/* Directly access properties from data */}
						<div className="tervuren-container__column-center-75">
							<div className="company-image-container">
								<img
									id="company-icon"
									src={location.logo !== null ? location.logo : logoDefault}
									alt="Location Icon"
								/>
							</div>
							<div className="map-image-container">
								<img
									id="map"
									src={location.map !== null ? location.map : mapDefault}
									alt="Location Map"
								/>
							</div>

							<h1 id="company-name" className="fw-800">
								{location.name}
							</h1>
							<p id="company-address">
								{location.address}, {location.state} {location.zip}
							</p>
							{location.location_contact_name && (
								<p id="location-contact-name">
									Location Contact: {location.location_contact_name}
								</p>
							)}
							<button className="tervuren-button-secondary" id="company-phone">
								<a href={`tel:${location.phone}`}>{location.phone}</a>
							</button>
							<button className="tervuren-button-secondary" id="company-email">
								<a href={`mailto:${location.email}`}>{location.email}</a>
							</button>
							<div className="mt-8 width-100 tervuren-container__row-center">
								{" "}
								<button
									className="tervuren-button-primary mt-2"
									id="checkin"
									onClick={handleCheckInClick}
								>
									Find Me
								</button>
							</div>
						</div>
					</div>
				) : (
					<p>No location data found</p>
				)}
			</div>
		);
	} else {
		return (
			<div className="tervuren-container__column-center bg-primary mh-100 flex-gap-1 topo-bg">
				<div className="tervuren-container__column-center-75 flex-gap-1">
					<img
						className="tervuren-logo_loading-page mb-4"
						src={tervurenLogo}
						alt="Shepherd Logo"
					/>
					<DotSpinner />
					<h3 className="mt-5">LOADING QR DATA</h3>
					<p className="text-center">
						If this process takes too long you may have incorrect information or
						the QR code is not valid anymore.
					</p>
					<p className="text-center">
						All contractors and visitors at this location must complete the
						training once per calendar year.
					</p>
					<div className="links-wrapper mt-2">
						<a
							className="underline mr-1"
							href="https://shepherdsafe.app/"
							target="_blank"
							rel="noreferrer"
						>
							shepherdsafe.app
						</a>
						<a
							className="underline"
							href="https://shepherdsafe.app/terms-conditions/"
							target="_blank"
							rel="noreferrer"
						>
							Shepherd Terms & Service
						</a>
					</div>
				</div>
			</div>
		);
	}
};

export default Checkin;
